import loadable from '@loadable/component'

// eslint-disable-next-line import/prefer-default-export
export const BackToTopButton = loadable(() => import('./BackToTopButton'))
